import { EntityType, TemplateType } from '../templates/templates.model';
import { Dictionary } from './model/shared.model';

type TokenType = {
    token: string;
    description: string;
    entity: Array<keyof typeof EntityType>;
    types: Array<keyof typeof TemplateType>;
};
export type TemplateTokenType = Dictionary<TokenType>;
export const TEMPLATE_TOKENS: TemplateTokenType = {
    FULL_NAME_TOKEN: {
        token: '{fullname}',
        description: 'GENERAL.FIELD.FULL_NAME',
        entity: ['EMPLOYEE', 'STUDENT'],
        types: ['DISCIPLINE_LETTER', 'CONTRACT', 'REGISTRATION'],
    },
    CLASS_TOKEN: {
        token: '{class}',
        description: 'EXAM_REGISTRATION.MESSAGE.USE_AS_CLASS',
        types: ['CONTRACT'],
        entity: ['STUDENT'],
    },
    PARENT_FULLNAME: {
        token: '{parentFullName}',
        description: 'CONTRACT_TEMPLATES.MESSAGE.USE_AS_STUDENT_PARENT',
        entity: ['STUDENT'],
        types: ['DISCIPLINE_LETTER', 'REGISTRATION'],
    },
    PARENT_TOKEN: {
        token: '{parent}',
        description: 'CONTRACT_TEMPLATES.MESSAGE.USE_AS_STUDENT_PARENT',
        entity: ['STUDENT'],
        types: ['CONTRACT', 'DISCIPLINE_LETTER'],
    },
    DATE_OF_BIRTH_TOKEN: {
        token: '{birthDate}',
        description: 'CONTRACT_TEMPLATES.MESSAGE.USE_AS_STUDENT_DATE_OF_BIRTH',
        entity: ['STUDENT', 'EMPLOYEE'],
        types: ['CONTRACT', 'REGISTRATION'],
    },
    DOCUMENT_NUMBER_TOKEN: {
        token: '{documentNumber}',
        description: 'CONTRACT_TEMPLATES.MESSAGE.USE_AS_STUDENT_DOCUMENT_NUMBER',
        entity: ['STUDENT', 'EMPLOYEE'],
        types: ['CONTRACT'],
    },
    DOCUMENT_GIVEN_DATE_TOKEN: {
        token: '{documentGivenDate}',
        description: 'CONTRACT_TEMPLATES.MESSAGE.USE_AS_DOCUMENT_GIVEN_DATE',
        entity: ['STUDENT', 'EMPLOYEE'],
        types: ['CONTRACT'],
    },
    DOCUMENT_DUE_DATE_TOKEN: {
        token: '{documentDueDate}',
        description: 'CONTRACT_TEMPLATES.MESSAGE.USE_AS_DOCUMENT_DUE_DATE',
        entity: ['STUDENT', 'EMPLOYEE'],
        types: ['CONTRACT'],
    },
    DOCUMENT_GIVEN_BY_TOKEN: {
        token: '{documentGivenBy}',
        description: 'CONTRACT_TEMPLATES.MESSAGE.USE_AS_DOCUMENT_GIVEN_BY',
        entity: ['STUDENT', 'EMPLOYEE'],
        types: ['CONTRACT'],
    },
    PERSONAL_ID_TOKEN: {
        token: '{personalId}',
        description: 'CONTRACT_TEMPLATES.MESSAGE.USE_AS_STUDENT_PERSONAL_ID',
        entity: ['STUDENT', 'EMPLOYEE'],
        types: ['CONTRACT'],
    },
    STUDENT_ID_TOKEN: {
        token: '{studentId}',
        description: 'CONTRACT_TEMPLATES.MESSAGE.USE_AS_STUDENT_ID',
        entity: ['STUDENT'],
        types: ['CONTRACT'],
    },
    PHONE_TOKEN: {
        token: '{phone}',
        description: 'CONTRACT_TEMPLATES.MESSAGE.USE_AS_STUDENT_PHONE',
        entity: ['STUDENT', 'EMPLOYEE'],
        types: ['CONTRACT'],
    },
    EMAIL_TOKEN: {
        token: '{email}',
        description: 'GENERAL.FIELD.EMAIL',
        entity: ['STUDENT', 'EMPLOYEE'],
        types: ['CONTRACT'],
    },
    CURRENT_DATE_TOKEN: {
        token: '{currentDate}',
        description: 'CONTRACT_TEMPLATES.MESSAGE.CURRENT_DATE',
        entity: ['STUDENT', 'EMPLOYEE'],
        types: ['CONTRACT', 'REGISTRATION', 'DISCIPLINE_LETTER', 'SCHOOL_LOG'],
    },
    CURRENT_TIME_TOKEN: {
        token: '{currentTime}',
        description: 'CONTRACT_TEMPLATES.MESSAGE.CURRENT_TIME',
        entity: ['STUDENT', 'EMPLOYEE'],
        types: ['CONTRACT', 'REGISTRATION', 'DISCIPLINE_LETTER', 'SCHOOL_LOG'],
    },
    STUDENT_FIRST_NAME: {
        token: '{firstname}',
        description: 'CONTRACT_TEMPLATES.MESSAGE.STUDENT_FIRST_NAME',
        entity: ['STUDENT'],
        types: ['CONTRACT', 'REGISTRATION', 'DISCIPLINE_LETTER', 'SCHOOL_LOG'],
    },
    STUDENT_MIDDLE_NAME: {
        token: '{middlename}',
        description: 'CONTRACT_TEMPLATES.MESSAGE.STUDENT_MIDDLE_NAME',
        entity: ['STUDENT'],
        types: ['CONTRACT', 'REGISTRATION', 'DISCIPLINE_LETTER', 'SCHOOL_LOG'],
    },
    STUDENT_LAST_NAME: {
        token: '{lastname}',
        description: 'CONTRACT_TEMPLATES.MESSAGE.STUDENT_LAST_NAME',
        entity: ['STUDENT'],
        types: ['CONTRACT', 'REGISTRATION', 'DISCIPLINE_LETTER', 'SCHOOL_LOG'],
    },
    STUDENT_ADDRESS_COUNTRY_TOKEN: {
        token: '{studentAddressCountry}',
        description: 'CONTRACT_TEMPLATES.MESSAGE.STUDENT_ADDRESS_COUNTRY',
        entity: ['STUDENT'],
        types: ['CONTRACT'],
    },
    STUDENT_ADDRESS_CITY_TOKEN: {
        token: '{studentAddressCity}',
        description: 'CONTRACT_TEMPLATES.MESSAGE.STUDENT_ADDRESS_CITY',
        entity: ['STUDENT'],
        types: ['CONTRACT'],
    },
    STUDENT_ADDRESS_STREET_TOKEN: {
        token: '{studentAddressStreet}',
        description: 'CONTRACT_TEMPLATES.MESSAGE.STUDENT_ADDRESS_STREET',
        entity: ['STUDENT'],
        types: ['CONTRACT'],
    },
    STUDENT_ADDRESS_POSTAL_CODE_TOKEN: {
        token: '{studentAddressPostalCode}',
        description: 'CONTRACT_TEMPLATES.MESSAGE.STUDENT_ADDRESS_POSTAL_CODE',
        entity: ['STUDENT'],
        types: ['CONTRACT'],
    },
    ADDRESS_COUNTRY_TOKEN: {
        token: '{addressCountry}',
        description: 'CONTRACT_TEMPLATES.MESSAGE.STUDENT_ADDRESS_COUNTRY',
        entity: ['STUDENT', 'EMPLOYEE'],
        types: ['CONTRACT'],
    },
    ADDRESS_CITY_TOKEN: {
        token: '{addressCity}',
        description: 'GENERAL.FIELD.CITY',
        entity: ['EMPLOYEE'],
        types: ['CONTRACT'],
    },
    ADDRESS_STREET_TOKEN: {
        token: '{addressStreet}',
        description: 'GENERAL.FIELD.STREET',
        entity: ['EMPLOYEE'],
        types: ['CONTRACT'],
    },
    ADDRESS_POSTAL_CODE_TOKEN: {
        token: '{addressPostalCode}',
        description: 'GENERAL.FIELD.POSTAL_CODE',
        entity: ['EMPLOYEE'],
        types: ['CONTRACT'],
    },
    STUDENT_CURRENT_CLASS_TOKEN: {
        token: '{studentCurrentClass}',
        description: 'CONTRACT_TEMPLATES.MESSAGE.STUDENT_CURRENT_CLASS',
        entity: ['STUDENT'],
        types: ['CONTRACT'],
    },
    STUDENT_CURRENT_GRADE_LEVEL_TOKEN: {
        token: '{studentCurrentGradeLevel}',
        description: 'CONTRACT_TEMPLATES.MESSAGE.STUDENT_CURRENT_GRADE_LEVEL',
        entity: ['STUDENT'],
        types: ['CONTRACT', 'REGISTRATION'],
    },
    STUDENT_CITIZENSHIP_TOKEN: {
        token: '{studentCitizenship}',
        description: 'CONTRACT_TEMPLATES.MESSAGE.STUDENT_CITIZENSHIP',
        entity: ['STUDENT'],
        types: ['CONTRACT'],
    },
    CITIZENSHIP_TOKEN: {
        token: '{citizenship}',
        description: 'GENERAL.FIELD.CITIZENSHIP',
        entity: ['EMPLOYEE'],
        types: ['CONTRACT'],
    },
    PARENT_ADDRESS_COUNTRY_TOKEN: {
        token: '{parentAddressCountry}',
        description: 'CONTRACT_TEMPLATES.MESSAGE.PARENT_ADDRESS_COUNTRY',
        entity: ['STUDENT'],
        types: ['CONTRACT'],
    },
    PARENT_ADDRESS_CITY_TOKEN: {
        token: '{parentAddressCity}',
        description: 'CONTRACT_TEMPLATES.MESSAGE.PARENT_ADDRESS_CITY',
        entity: ['STUDENT'],
        types: ['CONTRACT'],
    },
    PARENT_ADDRESS_STREET_TOKEN: {
        token: '{parentAddressStreet}',
        description: 'CONTRACT_TEMPLATES.MESSAGE.PARENT_ADDRESS_STREET',
        entity: ['STUDENT'],
        types: ['CONTRACT'],
    },
    PARENT_ADDRESS_POSTAL_CODE_TOKEN: {
        token: '{parentAddressPostalCode}',
        description: 'CONTRACT_TEMPLATES.MESSAGE.PARENT_ADDRESS_POSTAL_CODE',
        entity: ['STUDENT'],
        types: ['CONTRACT'],
    },
    PARENT_FULL_ADDRESS: {
        token: '{parentFullAddress}',
        description: 'CONTRACT_TEMPLATES.MESSAGE.PARENT_FULL_ADDRESS',
        entity: ['STUDENT'],
        types: ['DISCIPLINE_LETTER', 'REGISTRATION'],
    },
    PARENT_PHONE_TOKEN: {
        token: '{parentPhone}',
        description: 'CONTRACT_TEMPLATES.MESSAGE.PARENT_PHONE',
        entity: ['STUDENT'],
        types: ['CONTRACT', 'REGISTRATION'],
    },
    PARENT_EMAIL_TOKEN: {
        token: '{parentEmail}',
        description: 'CONTRACT_TEMPLATES.MESSAGE.PARENT_EMAIL',
        entity: ['STUDENT'],
        types: ['CONTRACT', 'REGISTRATION'],
    },
    PARENT_DATE_OF_BIRTH_TOKEN: {
        token: '{parentBirthDate}',
        description: 'CONTRACT_TEMPLATES.MESSAGE.PARENT_DATE_OF_BIRTH',
        entity: ['STUDENT'],
        types: ['CONTRACT'],
    },
    PARENT_DOCUMENT_NUMBER_TOKEN: {
        token: '{parentDocumentNumber}',
        description: 'CONTRACT_TEMPLATES.MESSAGE.PARENT_DOCUMENT_NUMBER',
        entity: ['STUDENT'],
        types: ['CONTRACT'],
    },
    PARENT_DOCUMENT_GIVEN_DATE_TOKEN: {
        token: '{parentDocumentGivenDate}',
        description: 'CONTRACT_TEMPLATES.MESSAGE.PARENT_DOCUMENT_GIVEN_DATE',
        entity: ['STUDENT'],
        types: ['CONTRACT'],
    },
    PARENT_DOCUMENT_DUE_DATE_TOKEN: {
        token: '{parentDocumentDueDate}',
        description: 'CONTRACT_TEMPLATES.MESSAGE.PARENT_DOCUMENT_DUE_DATE',
        entity: ['STUDENT'],
        types: ['CONTRACT'],
    },
    PARENT_DOCUMENT_GIVEN_BY_TOKEN: {
        token: '{parentDocumentGivenBy}',
        description: 'CONTRACT_TEMPLATES.MESSAGE.PARENT_DOCUMENT_GIVEN_BY',
        entity: ['STUDENT'],
        types: ['CONTRACT'],
    },
    PARENT_PERSONAL_ID_TOKEN: {
        token: '{parentPersonalId}',
        description: 'CONTRACT_TEMPLATES.MESSAGE.PARENT_PERSONAL_ID',
        entity: ['STUDENT'],
        types: ['CONTRACT'],
    },
    PARENT_CITIZENSHIP_TOKEN: {
        token: '{parentCitizenship}',
        description: 'CONTRACT_TEMPLATES.MESSAGE.PARENT_CITIZENSHIP',
        entity: ['STUDENT'],
        types: ['CONTRACT'],
    },
    PARENT_NATIONALITY_TOKEN: {
        token: '{parentNationality}',
        description: 'CONTRACT_TEMPLATES.MESSAGE.PARENT_NATIONALITY',
        entity: ['STUDENT'],
        types: ['CONTRACT'],
    },
    PARENT_TYPE_TOKEN: {
        token: '{parentType}',
        description: 'CONTRACT_TEMPLATES.MESSAGE.PARENT_TYPE',
        entity: ['STUDENT'],
        types: ['CONTRACT'],
    },
    PARENT_SECOND_TOKEN: {
        token: '{parentSecond}',
        description: 'CONTRACT_TEMPLATES.MESSAGE.PARENT_SECOND_FULLNAME',
        entity: ['STUDENT'],
        types: ['CONTRACT'],
    },
    PARENT_SECOND_ADDRESS_COUNTRY_TOKEN: {
        token: '{parentSecondAddressCountry}',
        description: 'CONTRACT_TEMPLATES.MESSAGE.PARENT_SECOND_ADDRESS_COUNTRY',
        entity: ['STUDENT'],
        types: ['CONTRACT'],
    },
    PARENT_SECOND_ADDRESS_CITY_TOKEN: {
        token: '{parentSecondAddressCity}',
        description: 'CONTRACT_TEMPLATES.MESSAGE.PARENT_SECOND_ADDRESS_CITY',
        entity: ['STUDENT'],
        types: ['CONTRACT'],
    },
    PARENT_SECOND_ADDRESS_STREET_TOKEN: {
        token: '{parentSecondAddressStreet}',
        description: 'CONTRACT_TEMPLATES.MESSAGE.PARENT_SECOND_ADDRESS_STREET',
        entity: ['STUDENT'],
        types: ['CONTRACT'],
    },
    PARENT_SECOND_ADDRESS_POSTAL_CODE_TOKEN: {
        token: '{parentSecondAddressPostalCode}',
        description: 'CONTRACT_TEMPLATES.MESSAGE.PARENT_SECOND_ADDRESS_POSTAL_CODE',
        entity: ['STUDENT'],
        types: ['CONTRACT'],
    },
    PARENT_SECOND_PHONE_TOKEN: {
        token: '{parentSecondPhone}',
        description: 'CONTRACT_TEMPLATES.MESSAGE.PARENT_SECOND_PHONE',
        entity: ['STUDENT'],
        types: ['CONTRACT'],
    },
    PARENT_SECOND_EMAIL_TOKEN: {
        token: '{parentSecondEmail}',
        description: 'CONTRACT_TEMPLATES.MESSAGE.PARENT_SECOND_EMAIL',
        entity: ['STUDENT'],
        types: ['CONTRACT'],
    },
    PARENT_SECOND_DATE_OF_BIRTH_TOKEN: {
        token: '{parentSecondBirthDate}',
        description: 'CONTRACT_TEMPLATES.MESSAGE.PARENT_SECOND_DATE_OF_BIRTH',
        entity: ['STUDENT'],
        types: ['CONTRACT'],
    },
    PARENT_SECOND_DOCUMENT_NUMBER_TOKEN: {
        token: '{parentSecondDocumentNumber}',
        description: 'CONTRACT_TEMPLATES.MESSAGE.PARENT_SECOND_DOCUMENT_NUMBER',
        entity: ['STUDENT'],
        types: ['CONTRACT'],
    },
    PARENT_SECOND_DOCUMENT_GIVEN_DATE_TOKEN: {
        token: '{parentSecondDocumentGivenDate}',
        description: 'CONTRACT_TEMPLATES.MESSAGE.PARENT_SECOND_DOCUMENT_GIVEN_DATE',
        entity: ['STUDENT'],
        types: ['CONTRACT'],
    },
    PARENT_SECOND_DOCUMENT_DUE_DATE_TOKEN: {
        token: '{parentSecondDocumentDueDate}',
        description: 'CONTRACT_TEMPLATES.MESSAGE.PARENT_SECOND_DOCUMENT_DUE_DATE',
        entity: ['STUDENT'],
        types: ['CONTRACT'],
    },
    PARENT_SECOND_DOCUMENT_GIVEN_BY_TOKEN: {
        token: '{parentSecondDocumentGivenBy}',
        description: 'CONTRACT_TEMPLATES.MESSAGE.PARENT_SECOND_DOCUMENT_GIVEN_BY',
        entity: ['STUDENT'],
        types: ['CONTRACT'],
    },
    PARENT_SECOND_PERSONAL_ID_TOKEN: {
        token: '{parentSecondPersonalId}',
        description: 'CONTRACT_TEMPLATES.MESSAGE.PARENT_SECOND_PERSONAL_ID',
        entity: ['STUDENT'],
        types: ['CONTRACT'],
    },
    PARENT_SECOND_CITIZENSHIP_TOKEN: {
        token: '{parentSecondCitizenship}',
        description: 'CONTRACT_TEMPLATES.MESSAGE.PARENT_SECOND_CITIZENSHIP',
        entity: ['STUDENT'],
        types: ['CONTRACT'],
    },
    PARENT_SECOND_NATIONALITY_TOKEN: {
        token: '{parentSecondNationality}',
        description: 'CONTRACT_TEMPLATES.MESSAGE.PARENT_SECOND_NATIONALITY',
        entity: ['STUDENT'],
        types: ['CONTRACT'],
    },
    PARENT_SECOND_TYPE_TOKEN: {
        token: '{parentSecondType}',
        description: 'CONTRACT_TEMPLATES.MESSAGE.PARENT_SECOND_TYPE',
        entity: ['STUDENT'],
        types: ['CONTRACT'],
    },
    EMPLOYEE_ID_TOKEN: {
        token: '{employeeId}',
        description: 'EMPLOYEE.TITLE.ID',
        entity: ['EMPLOYEE'],
        types: ['CONTRACT'],
    },
    INCIDENT_DATE: {
        token: '{incidentDate}',
        description: 'CONTRACT_TEMPLATES.MESSAGE.INCIDENT_DATE',
        entity: ['STUDENT'],
        types: ['DISCIPLINE_LETTER'],
    },
    CONTRACT_START_DATE: {
        token: '{contractStartDate}',
        description: 'CONTRACT_TEMPLATES.MESSAGE.CONTRACT_START_DATE',
        entity: ['EMPLOYEE'],
        types: ['CONTRACT'],
    },
    CONTRACT_END_DATE: {
        token: '{contractEndDate}',
        description: 'CONTRACT_TEMPLATES.MESSAGE.CONTRACT_END_DATE',
        entity: ['EMPLOYEE'],
        types: ['CONTRACT'],
    },
    CONTRACT_NUMBER_TOKEN: {
        token: '{contractNumber}',
        description: 'CONTRACT_TEMPLATES.MESSAGE.CONTRACT_NUMBER',
        entity: ['EMPLOYEE'],
        types: ['CONTRACT'],
    },
    REGISTRATION_NAME_TOKEN: {
        token: '{registration_name}',
        description: 'CONTRACT_TEMPLATES.MESSAGE.REGISTRATION_NAME',
        entity: ['STUDENT'],
        types: ['REGISTRATION'],
    },
    REGISTRATION_ID_TOKEN: {
        token: '{registration_number}',
        description: 'CONTRACT_TEMPLATES.MESSAGE.REGISTRATION_NUMBER',
        entity: ['STUDENT'],
        types: ['REGISTRATION'],
    },
    PARENT_FIRST_NAME1: {
        token: '{parent_firstname_1}',
        description: 'CONTRACT_TEMPLATES.MESSAGE.PARENT_FIRST_NAME1',
        entity: ['STUDENT'],
        types: ['REGISTRATION'],
    },
    PARENT_LAST_NAME1: {
        token: '{parent_lastname_1}',
        description: 'CONTRACT_TEMPLATES.MESSAGE.PARENT_LAST_NAME1',
        entity: ['STUDENT'],
        types: ['REGISTRATION'],
    },
    PARENT_RELETIONSHIP1: {
        token: '{parent_relationship_1}',
        description: 'CONTRACT_TEMPLATES.MESSAGE.PARENT_RELATIONSHIP1',
        entity: ['STUDENT'],
        types: ['REGISTRATION'],
    },
    STUDENT_GENDER: {
        token: '{gender}',
        description: 'GENERAL.FIELD.GENDER',
        entity: ['STUDENT'],
        types: ['REGISTRATION'],
    },
    STUDENT_PREV_SCHOOL: {
        token: '{previous_school}',
        description: 'EXAM_REGISTRATION.FIELD.PREV_SCHOOL',
        entity: ['STUDENT'],
        types: ['REGISTRATION'],
    },
    REGISTRATION_START_DATE: {
        token: '{start_date}',
        description: 'CONTRACT_TEMPLATES.MESSAGE.REGISTRATION_START_DATE',
        entity: ['STUDENT'],
        types: ['REGISTRATION'],
    },
    REGISTRATION_END_DATE: {
        token: '{end_date}',
        description: 'CONTRACT_TEMPLATES.MESSAGE.REGISTRATION_END_DATE',
        entity: ['STUDENT'],
        types: ['REGISTRATION'],
    },
    MESSAGE: {
        token: '{message}',
        description: 'GENERAL.FIELD.MESSAGE',
        entity: ['STUDENT'],
        types: ['SCHOOL_LOG'],
    },
};

export class SharedConstants {
    public static preRegisterFileTypeProperty = 'preRegister.attachment.fileType';
    public static studentFileTypeProperty = 'student.attachment.fileType';
    public static employeeFileTypeProperty = 'employee.attachment.fileType';
    public static defaultFileTypeProperty = 'default.attachment.fileType';

    public static preRegisterFileSizeProperty = 'preRegister.attachment.fileSize';
    public static studentFileSizeProperty = 'student.attachment.fileSize';
    public static employeeFileSizeProperty = 'employee.attachment.fileSize';
    public static defaultFileSizeProperty = 'default.attachment.fileSize';
    public static gatewayDefaultFileSize = 1024 * 1024;

    public static profilePhotoSize = 'profile.photo.fileSize';
    public static defaultCalendarEventWeeks = 4;

    public static megaByteToKiloByteValue = 1024 * 1024;

    public static fileTypePropertySplitter = ',';
    public static GOOGLE_DRIVE = 'GOOGLE_DRIVE';
    public static MY_DRIVE = 'MY_DRIVE';
    public static fileNameMaxSize = 255;
    public static salaryRateMaxValue = 'salary.rate.max.value';
    public static examUiDomainName = 'exam.ui.domain.name';
    public static FULL_NAME_TOKEN = '{fullname}';
    public static DIRECTOR_TOKEN = '{director_fullname}';
    public static POSITION_TOKEN = '{position}';
    public static CLASS_TOKEN = '{class}';
    public static TRANSFERRING_CLASS_TOKEN = '{transferring_class}';
    public static FIRST_NAME_TOKEN = '{firstname}';
    public static MIDDLE_NAME_TOKEN = '{middlename}';
    public static LAST_NAME_TOKEN = '{lastname}';
    public static PARENT_FULLNAME = '{parentFullName}';
    public static PARENT_TOKEN = '{parent}';
    public static PARENT_FIRST_NAME_TOKEN = '{parent_firstname}';
    public static PARENT_MIDDLE_NAME_TOKEN = '{parent_middlename}';
    public static PARENT_LAST_NAME_TOKEN = '{parent_lastname}';
    public static EXAM_DATE_TOKEN = '{examdate}';
    public static EXAM_TIME_TOKEN = '{examtime}';
    public static EXAM_PLACE_TOKEN = '{examplace}';
    public static EXAM_NAME_TOKEN = '{examname}';
    public static DATE_OF_BIRTH_TOKEN = '{birthDate}';
    public static DOCUMENT_NUMBER_TOKEN = '{documentNumber}';
    public static DOCUMENT_GIVEN_DATE_TOKEN = '{documentGivenDate}';
    public static DOCUMENT_DUE_DATE_TOKEN = '{documentDueDate}';
    public static DOCUMENT_GIVEN_BY_TOKEN = '{documentGivenBy}';
    public static PERSONAL_ID_TOKEN = '{personalId}';
    public static STUDENT_ID_TOKEN = '{studentId}';
    public static PHONE_TOKEN = '{phone}';
    public static EMAIL_TOKEN = '{email}';
    public static CURRENT_DATE_TOKEN = '{currentDate}';
    public static CURRENT_TIME_TOKEN = '{currentTime}';
    public static STUDENT_FIRSTNAME = '{firstname}';
    public static STUDENT_ADDRESS_COUNTRY_TOKEN = '{studentAddressCountry}';
    public static STUDENT_ADDRESS_CITY_TOKEN = '{studentAddressCity}';
    public static STUDENT_ADDRESS_STREET_TOKEN = '{studentAddressStreet}';
    public static STUDENT_ADDRESS_POSTAL_CODE_TOKEN = '{studentAddressPostalCode}';
    public static ADDRESS_COUNTRY_TOKEN = '{addressCountry}';
    public static ADDRESS_CITY_TOKEN = '{addressCity}';
    public static ADDRESS_STREET_TOKEN = '{addressStreet}';
    public static ADDRESS_POSTAL_CODE_TOKEN = '{addressPostalCode}';
    public static STUDENT_CURRENT_CLASS_TOKEN = '{studentCurrentClass}';
    public static STUDENT_CURRENT_GRADE_LEVEL_TOKEN = '{studentCurrentGradeLevel}';
    public static STUDENT_CITIZENSHIP_TOKEN = '{studentCitizenship}';
    public static CITIZENSHIP_TOKEN = '{citizenship}';
    public static PARENT_ADDRESS_COUNTRY_TOKEN = '{parentAddressCountry}';
    public static PARENT_ADDRESS_CITY_TOKEN = '{parentAddressCity}';
    public static PARENT_ADDRESS_STREET_TOKEN = '{parentAddressStreet}';
    public static PARENT_ADDRESS_POSTAL_CODE_TOKEN = '{parentAddressPostalCode}';
    public static PARENT_FULL_ADDRESS = '{parentFullAddress}';
    public static PARENT_PHONE_TOKEN = '{parentPhone}';
    public static PARENT_EMAIL_TOKEN = '{parentEmail}';
    public static PARENT_DATE_OF_BIRTH_TOKEN = '{parentBirthDate}';
    public static PARENT_DOCUMENT_NUMBER_TOKEN = '{parentDocumentNumber}';
    public static PARENT_DOCUMENT_GIVEN_DATE_TOKEN = '{parentDocumentGivenDate}';
    public static PARENT_DOCUMENT_DUE_DATE_TOKEN = '{parentDocumentDueDate}';
    public static PARENT_DOCUMENT_GIVEN_BY_TOKEN = '{parentDocumentGivenBy}';
    public static PARENT_PERSONAL_ID_TOKEN = '{parentPersonalId}';
    public static PARENT_CITIZENSHIP_TOKEN = '{parentCitizenship}';
    public static PARENT_NATIONALITY_TOKEN = '{parentNationality}';
    public static PARENT_TYPE_TOKEN = '{parentType}';

    public static TEACHER_TOKEN = '{teacherName}';

    public static PARENT_SECOND_TOKEN = '{parentSecond}';
    public static PARENT_SECOND_ADDRESS_COUNTRY_TOKEN = '{parentSecondAddressCountry}';
    public static PARENT_SECOND_ADDRESS_CITY_TOKEN = '{parentSecondAddressCity}';
    public static PARENT_SECOND_ADDRESS_STREET_TOKEN = '{parentSecondAddressStreet}';
    public static PARENT_SECOND_ADDRESS_POSTAL_CODE_TOKEN = '{parentSecondAddressPostalCode}';
    public static PARENT_SECOND_PHONE_TOKEN = '{parentSecondPhone}';
    public static PARENT_SECOND_EMAIL_TOKEN = '{parentSecondEmail}';
    public static PARENT_SECOND_DATE_OF_BIRTH_TOKEN = '{parentSecondBirthDate}';
    public static PARENT_SECOND_DOCUMENT_NUMBER_TOKEN = '{parentSecondDocumentNumber}';
    public static PARENT_SECOND_DOCUMENT_GIVEN_DATE_TOKEN = '{parentSecondDocumentGivenDate}';
    public static PARENT_SECOND_DOCUMENT_DUE_DATE_TOKEN = '{parentSecondDocumentDueDate}';
    public static PARENT_SECOND_DOCUMENT_GIVEN_BY_TOKEN = '{parentSecondDocumentGivenBy}';
    public static PARENT_SECOND_PERSONAL_ID_TOKEN = '{parentSecondPersonalId}';
    public static PARENT_SECOND_CITIZENSHIP_TOKEN = '{parentSecondCitizenship}';
    public static PARENT_SECOND_NATIONALITY_TOKEN = '{parentSecondNationality}';
    public static PARENT_SECOND_TYPE_TOKEN = '{parentSecondType}';
    public static EMPLOYEE_ID_TOKEN = '{employeeId}';

    public static INCIDENT_DATE = '{incidentDate}';
    public static CONTRACT_START_DATE = '{contractStartDate}';
    public static CONTRACT_END_DATE = '{contractEndDate}';
    public static CONTRACT_NUMBER_TOKEN = '{contractNumber}';

    public static TOTAL_FEE = '{fee}';
    public static DEBT = '{debt}';
    public static NET_DEBT = '{netdebt}';
    public static TOTAL_PAID = '{totalpaid}';
    public static DATE_TO = '{dateto}';
    public static COURSES = '{courses}';
    public static DATE = '{date}';
    public static TIME = '{time}';
    public static COURSE_NAME = '{coursename}';
    public static PERIOD_COURSE = '{period_course}';

    public static REG_NUMBER_TOKEN = '{reg_number}';

    public static CERTIFY_DATE_TOKEN = '{certifyDate}';
    public static CERTIFIER_TOKEN = '{certifier}';
    public static CERTIFIER_POSITION_TOKEN = '{certifierPosition}';

    public static REG_NUMBER_DIGITS = 6;
    public static FORMULA_ERROR_BACKGROUND_COLOR = '#e66c6c';
    public static WORK_CALENDAR_NON_WORKING_DAY_COLOR = '#f06292';
    public static NEW_ROW = '#fff9c4';
    public static TIME_SHEET_BALANCE_TEXT_COLOR_RED = '#ff0000';
    public static TIME_SHEET_BALANCE_TEXT_COLOR_GREEN = '#008000';
    public static TIME_SHEET_BALANCE_TEXT_COLOR_BLACK = '#000000';
    public static TEXT_COLOR_RED = '#ff0000';
    public static TEXT_COLOR_BLUE = '#0000ff';

    public static PHOTO_TYPES: string[] = ['png', 'jpeg', 'jpg', 'tiff', 'bpm', 'bpg', 'jfif'];

    public static KZ_REPORT_FAMILY_COUNT = 'REPORT_FAMILY_COUNT';
    public static KZ_REPORT_NATIVE_LANGUAGE = 'REPORT_NATIVE_LANGUAGE';
    public static KZ_REPORT_PRE_SCHOOL_EDUCATION = 'REPORT_PRE_SCHOOL_EDUCATION';
    public static KZ_REPORT_AWARDS = 'REPORT_AWARDS';
    public static KZ_REPORT_FAMILY_CATEGORY = 'REPORT_FAMILY_CATEGORY';

    public static ROLE_ADMIN = 'ROLE_ADMIN';
    public static ROLE_HEAD_TEACHER = 'ROLE_HEAD_TEACHER';
    public static ROLE_STUDENT_ADMISSION = 'ROLE_STUDENT_ADMISSION';
    public static ROLE_TENANT_ADMIN = 'ROLE_TENANT_ADMIN';
    public static ROLE_SCHOOL_ADMIN = 'ROLE_SCHOOL_ADMIN';
    public static ROLE_INCIDENT_MANAGER = 'ROLE_INCIDENT_MANAGER';
    public static ROLE_MANAGER = 'ROLE_MANAGER';
    public static ROLE_SYSTEM = 'ROLE_SYSTEM';
    public static ROLE_TEACHER = 'ROLE_TEACHER';
    public static ROLE_EMPLOYEE = 'ROLE_EMPLOYEE';
    public static ROLE_STUDENT = 'ROLE_STUDENT';
    public static ROLE_PARENT = 'ROLE_PARENT';
    public static ROLE_AUDITOR = 'ROLE_AUDITOR';
    public static EDITOR_CONFIG = {
        base_url: '/tinymce',
        //license_key: 'gpl',
        suffix: '.min',
        language: 'en',
        language_url: '',
        height: '400px',
        menubar: true,
        placeholder: '',
        inline: false,
        toolbar_sticky: true,
        image_advtab: true,
        importcss_append: true,
        image_caption: true,
        quickbars_selection_toolbar: 'bold italic | quicklink h2 h3 blockquote quickimage quicktable',
        noneditable_noneditable_class: 'mceNonEditable',
        toolbar_mode: 'sliding',
        draggable_modal: true,
        htmlAllowedTags: ['.*'],
        htmlAllowedAttrs: ['.*'],
        extended_valid_elements: '*[.*]',
        powerpaste_allow_local_images: true,
        default_link_target: '_blank',
        promotion: false,
        // extended_valid_elements: 'a[href|target=_blank]',
        powerpaste_word_import: 'prompt',
        powerpaste_html_import: 'prompt',
        contextmenu: 'link image table',
        font_family_formats:
            'Andale Mono=andale mono,times; Arial=arial,helvetica,sans-serif; Arial Black=arial black,avant garde; Book Antiqua=book antiqua,palatino; Comic Sans MS=comic sans ms,sans-serif; Courier New=courier new,courier; Georgia=georgia,palatino;Gulzar - Urdu=Gulzar;Helvetica=helvetica; Impact=impact,chicago; Jameel Khushkhati=Jameel Khushkhat-LK;Symbol=symbol; Tahoma=tahoma,arial,helvetica,sans-serif; Terminal=terminal,monaco; Times New Roman=times new roman,times; Trebuchet MS=trebuchet ms,geneva; Verdana=verdana,geneva; Webdings=webdings; Wingdings=wingdings,zapf dingbats',
        content_style:
            '@import url(https://db.onlinewebfonts.com/c/48f3412c1b6c0c090e7a6dd362b3dbec?family=Jameel+Khushkhat-LK);@import url("https://fonts.googleapis.com/css2?family=Gulzar&display=swap"); body { font-family: Arial,"Jameel Khushkhat-LK",Gulzar; } .pagebreak {page-break-before: always;}',
        plugins:
            'preview importcss searchreplace autolink autosave save directionality code visualblocks visualchars fullscreen image link media codesample table charmap pagebreak nonbreaking anchor insertdatetime advlist lists wordcount charmap quickbars emoticons',
        toolbar:
            'undo redo | bold italic underline strikethrough | fontselect | fontfamily fontsizeinput blocks | fullscreen | alignleft aligncenter alignright alignjustify | outdent indent |  numlist bullist | forecolor backcolor removeformat | pagebreak | charmap emoticons |  preview save print | insertfile image media link anchor codesample | ltr rtl | tiny_mce_wiris_formulaEditor tiny_mce_wiris_formulaEditorChemistry | lineheight | block',
        external_plugins: {},
        emoticons_database: 'emojis',
        table_default_attributes: {
            border: '0',
        },
        selector: '',
        indentation: '20pt',
        keep_styles: false,
        newline_behavior: 'linebreak',
        line_height_formats: '1 1.2 1.4 1.6 1.8 2 2.2 2.4 2.6 2.8 3',
        font_size_formats: '8pt 10pt 11pt 12pt 13pt 14pt 15pt 16pt 18pt 20pt 24pt 28pt 32pt 36pt 48pt',
        setup: undefined,
    };
    public static EDITOR_CONFIG_SIMPLE = {
        base_url: '/tinymce',
        //license_key: 'gpl',
        suffix: '.min',
        height: '400px',
        max_height: 'calc(100vh - 220px)',
        powerpaste_allow_local_images: true,
        default_link_target: '_blank',
        extended_valid_elements: 'a[href|target=_blank]',
        powerpaste_word_import: 'prompt',
        powerpaste_html_import: 'prompt',
        menubar: false,
        promotion: false,
        indentation: '20pt',
        keep_styles: false,
        table_default_attributes: {
            border: '0',
        },
        newline_behavior: 'linebreak',
        line_height_formats: '1 1.2 1.4 1.6 1.8 2 2.2 2.4 2.6 2.8 3',
        font_size_formats: '8pt 10pt 11pt 12pt 13pt 14pt 15pt 16pt 18pt 20pt 24pt 28pt 32pt 36pt 48pt',
        font_family_formats:
            'Andale Mono=andale mono,times; Arial=arial,helvetica,sans-serif; Arial Black=arial black,avant garde; Book Antiqua=book antiqua,palatino; Comic Sans MS=comic sans ms,sans-serif; Courier New=courier new,courier; Georgia=georgia,palatino; Gulzar - Urdu=Gulzar; Helvetica=helvetica; Impact=impact,chicago;Jameel Khushkhati=Jameel Khushkhat-LK;Symbol=symbol; Tahoma=tahoma,arial,helvetica,sans-serif; Terminal=terminal,monaco; Times New Roman=times new roman,times; Trebuchet MS=trebuchet ms,geneva; Verdana=verdana,geneva; Webdings=webdings; Wingdings=wingdings,zapf dingbats',
        content_style:
            '@import url(https://db.onlinewebfonts.com/c/48f3412c1b6c0c090e7a6dd362b3dbec?family=Jameel+Khushkhat-LK);@import url("https://fonts.googleapis.com/css2?family=Gulzar&display=swap"); body { font-family: Arial,"Jameel Khushkhat-LK",Gulzar; } .pagebreak {page-break-before: always;}',
        toolbar1:
            'undo redo | bold italic underline strikethrough | fontselect fontsizeinput formatselect | alignleft aligncenter alignright alignjustify | outdent indent | lineheight | block | forecolor backcolor',
    };

    public static ACADEMIC_CALENDAR_PUBLIC_HOLIDAY = '#ef9a9a';
    public static ACADEMIC_CALENDAR_WEEKEND = '#ffe082';
    public static ACADEMIC_CALENDAR_START_END_OF_TERM = '#a5d6a7';
    public static ACADEMIC_CALENDAR_TERM_BREAK = '#9fa8da';
    public static COURSE_SCHEDULE_BOARD_PUBLIC_HOLIDAY = 'rgba(239,154,154,0.2)';
    public static COURSE_SCHEDULE_BOARD_WEEKEND = 'rgba(255,224,130,0.2)';
    public static COURSE_SCHEDULE_BOARD_START_END_OF_TERM = 'rgba(165,214,167,0.2)';
    public static COURSE_SCHEDULE_BOARD_TERM_BREAK = 'rgba(159,168,218,0.2)';

    public static ACADEMIC_CALENDAR_ATTENDANCE_ATTENDED = '#a5d6a7';
    public static ACADEMIC_CALENDAR_ATTENDANCE_TARDY = '#ffbd62';
    public static ACADEMIC_CALENDAR_ATTENDANCE_ABSENT = '#ffeaea';
    public static ACADEMIC_CALENDAR_ATTENDANCE_FULL_ABSENT = '#ffb2b2';
    public static ACADEMIC_CALENDAR_ATTENDANCE_EXCUSED = '#6dd2ff';

    public static TEXT_TO_SPEECH_GOOGLE_AUDIO_LINK = 'https://cloud.google.com/static/text-to-speech/docs/audio/';
}
